import SelectAbstract from "components/SelectAbstract";

import Input from "components/Input";
import Calendar from "components/Calendar";

import { ReactComponent as CalendarIcon } from 'icons/components/calendar.svg';

import './themes/default.less';
import './index.less';

export default class SelectDateRange extends SelectAbstract {

    constructor(props) {
        super(props);

        /*
        this.periods = [1, 2, 3, 4, 5, 6, 12].map(id => {
            const name = ((id === 1 || id === 12) ? "1 " : "") + this._helper.date.diffFrom(null, this._helper.date.addMonth(null, id));
            return { id, name };
        });

        this.state = {
            value1: new Date(),
            selected: new Date(),
            index: -1
        };*/

        this.periods = [1, 2, 3, 4, 5, 6, 12].map(id => {
            const name = ((id === 1 || id === 12) ? "1 " : "") + this._helper.date.diffFrom(null, this._helper.date.addMonth(null, id));
            return { id, name };
        });

        const initialDate = props.defaultValue ? this._helper.date.create(props.defaultValue) : null;

        this.state = {
            value1: initialDate,
            selected: initialDate,
            index: -1
        };
    }

    componentDidUpdate(prevProps) {
        if (prevProps.defaultValue !== this.props.defaultValue) {
            const newDate = this._helper.date.create(this.props.defaultValue);
            this.setState({
                value1: newDate,
                selected: newDate,
            });
            this.inputDate.value = this._helper.date.toStr(newDate, 'DD.MM.YYYY');
        }
    }

    set value(date) {
        const newDate = this._helper.date.create(date);
        this.setState({
            value1: newDate,
            selected: newDate,
        });
        this.inputDate.value = this._helper.date.toStr(newDate, 'DD.MM.YYYY');
    }

    get value() {
        return this.state.value1;
    }

    getMainStyle() {
        return "selectDateRange";
    }

    onChange(date) {
        this.inputDate.value = this._helper.date.toStr(date, 'DD.MM.YYYY');
        this.state.index = 1;
        this.setOpenedState(false);
        this.validate();
        this.setState({ value1: date });

        if (this.props.onChange?.apply)
            this.props.onChange(date);
    }

    onCalendarFirstMonthChange(date) {
        this.changeState('value1', date);
    }

    validate() {
        this.inputDate.validate();
    }

    renderSelector() {
        const { value1 } = this.state;
        const { label } = this.props;

        return (
            <div ref={el => this.selector = el} className="selectorDate flex col gap8 hand" onClick={this.toggleOpenedState.bind(this)}>
                <Input
                    ref={el => this.inputDate = el}
                    placeHolder="client.date"
                    readonly={true}
                    label={label ? label : "main.validity"}
                    required={true}
                    value={value1 ? this._helper.date.toStr(value1, 'DD MMMM, YYYY') : ""}
                    iconRight={<CalendarIcon />}
                />
            </div>
        );
    }

    onAddMonth(n) {
        const selected = this._helper.date.addMonth(null, n);
        const date = this._helper.date.toStr(selected);
        this.inputDate.value = this._helper.date.toStr(date, 'DD.MM.YYYY');
        this.setState({ selected, value1: selected });
        this.setOpenedState(false);
        if (this.props.onChange?.apply)
            this.props.onChange(selected);
    }

    renderRangeType(text, id) {
        return (
            <div
                key={"type" + id}
                className={`rangeType text p1 hand`}
                onClick={this.onAddMonth.bind(this, id)}>
                {this.tr(text)}
            </div>
        );

    }

    renderPopup() {
        const { value1, selected } = this.state;

        return (
            <div ref={el => this.popup = el} className="selectPopup pos abs ">
                <div className="flex col gap16">
                    <div className="flex centerH gap16">
                        <div className="calendarCont">
                            <Calendar
                                value={value1 ? value1 : new Date()}
                                selected={selected ? selected : new Date()}
                                onChange={this.onChange.bind(this)}
                                pastOff={true}
                                onMonthChange={this.onCalendarFirstMonthChange.bind(this)}
                            />
                        </div>
                        <div className="rangeTypeBlock flex col gap2">
                            {this.periods.map(it => this.renderRangeType(it.name, it.id))}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
